export default "__VITE_ASSET__ddb3abde__"